<!--
IMPORTACAO DE CADASTROS PELO XML DA NF-E
-->

<script>
import BarList from '../components/bar-list'
import { apiORDS, apiORDSpost, urlORDS } from '../shared/api-functions'
import axios from 'axios'
import { getText, formatDate, formatValue } from '../shared/utils'
import { SysVars } from '../main';
import { apiDownloadFile, apiDownloadPDF } from '../shared/api-functions'

export default {
  data() {

    return {
      showForm: false, //exibe a tela de manutencao
      filial: '',
      codfil: '',
      metadata: this.$store.getters.getEntities.metadata,
      filter: '',
      filesJson: [],
      resultList: [],
      showSelecionaArquivos: true,
      showConfirmaImportacao: false,
      xmlcount: 0,
      xmlhist: '',
    }
  },

  computed: {
    qtFiles: function () {
      return this.filesJson.length
    },
    xmlhistList: function () {
      return this.$store.getters.getXMLHistList
    },


  },

  filters: {
    getText: function (value, metadata) {
      return getText(value, metadata)
    },
  },

  methods: {
    handleFileSelectBtn() {
      //BOTAO SELECIONAR ARQUIVOS
      this.$refs.file.value = ''
      this.$refs.file.click()
    },

    handleFileUpload() {
      //EVENTO AO SELECIONAR ARQUIVOS
      //EFETUA A LEITURA DE CADA ARQUIVO SELECIONADO ATRAVES DO SERVIDOR (SERVIDOR RETORNA O XML)

      //console.log(this.$refs.file.files)

      var files = this.$refs.file.files
      this.filesJson = []

      if (files.length > 100) {
        this.$erpToastError('Seleção não permitida. O limite máximo é de 100 arquivos por importação.')
        return
      }

      let self = this

      //formData.append('file', this.selectedFile)
      for (var i = 0; i < files.length; i++) {
        let file = files[i]
        let reader = new FileReader()
        reader.readAsText(file, 'ISO-8859-1')
        reader.onload = function (event) {
          let xml = event.target.result
          self.readXml(xml, file.name)
        }
      }
      this.showSelecionaArquivos = false
      this.showConfirmaImportacao = true
    },

    readXml(xml, filename) {
      let self = this
      let formData = new FormData()
      formData.append('file', new Blob([xml]), filename)
      axios.post(urlORDS(this.$store, 'cg/importreadxml/'), formData,
        { headers: { 'Content-Type': 'multipart/form-data', } }
      ).then(function (data) {
        let addfile = { filename: filename, xml: data.data }
        self.filesJson.push(addfile)
        console.log(self.filesJson)
      })
        .catch(function (data) {
          self.$erpToastError('Erro ao efetuar upload do arquivo ' + file.name + ': ' + data.message)
        })
    },

    handleExecutaImportacao() {
      //ENVIA O OBJETO JSON PARA IMPORTAÇÃO
      //RETORNA UM OBJETO ARRAY COM A SITUACAO DE CADA ITEM IMPORTADO E OS ERROS SE HOUVER
      //[ filename: "", status: "ok", errormessage: "", text: ""]

      let sendData = { xmls: this.filesJson, gravaXML: true }
      this.resultList = []

      var self = this

      axios.post(urlORDS(this.$store, 'cg/importxml/'), sendData, {})
        .then(function (data) {
          // console.log(data.data)
          self.xmlcount = data.data.xmlcount
          self.resultList = data.data.result
          self.$erpToastSuccess('Importação executada')
          self.showConfirmaImportacao = false
        })
        .catch(function (data) {
          self.$erpToastError('Erro ao efetuar importação ' + data.message)
        })
    },

    search(value) {
      //efetua a pesquisa
      if (value) {
        this.filter = '{"$or":[{"nnf":{"$eq":"' + value + '"}}]}'
      } else {
        this.filter = null;
      }
      this.loadData()
    },

    loadData() {
      this.$store.dispatch('loadXMLHist', { filter: this.filter })
      this.offset = ''
    },

    handleRetornar() {
      this.resultList = []
      this.showSelecionaArquivos = true
      this.showConfirmaImportacao = false
    },

    handlePDF(chnfe) {
      //impressao da danfe em PDF

      apiDownloadPDF(this, 'cg/xmlhist/' + chnfe + '/danfe')
    },

    handleDownloadXML(xml, chnfe) {
      //visualizacao do XML da NFE
      var response = {}
      response.data = xml
      apiDownloadFile(response, chnfe + '.xml')
    },

  },

  components: {
    BarList
  },

  created() {
    //this.loadData()
  }

}

</script>

<template>
  <div>
    <bar-manut single-entity="Importação de Notas por XML" :disableSave="true" :disableRetorno="true">
    </bar-manut>

    <div class="default-container" v-if="showSelecionaArquivos">
      <label-title title="Selecionar Arquivos XML de NF-e" class="mb-2"></label-title>
      <span class="w-100 lbl">Importe suas notas fiscais eletrônicas por XML para armazená-las no Nota Brasil e gerar a
        DANFE.</span>
      <hr>
      <div class="row mt-5 mb-5">
        <div class="col-md-12">
          <span class="w-100 lbl-edit">Selecione até 100 arquivos XML.</span>
        </div>
        <div class="col-md-12 mt-2">
        </div>
        <div class="col-md-12 mt-2">
          <!-- <alert v-if="errmessage" type="warning" title="Erro na importação do arquivo" :text="errmessage"></alert> -->
        </div>
      </div>
      <hr>
      <div class="row">
        <div class="col-md-12 mt-2">
          <v-button label="Selecionar os Arquivos XML" :nb-btdef="false" icon="fa-upload"
            @click="handleFileSelectBtn()"></v-button>
          <!-- <v-button label="Continuar" :nb-btdef="true" @click="handleAnalisarArquivo()"></v-button> -->
          <!-- <v-button label="Cancelar" @click="handleRetornar()"></v-button> -->
        </div>
      </div>
    </div>

    <div class="default-container" v-if="showConfirmaImportacao">
      <label-title title="Confirmar Importação" class="mb-2"></label-title>
      <hr>
      <div class="row">
        <div class="col-md-12">
          <alert type="warning" text="Serão ignoradas as notas fiscais já importadas pelo sistema."></alert>
        </div>
      </div>
      <div class="row mt-5">
        <div class="col-md-12">
          <span class="w-100 lbl-edit">Deseja continuar a importação de {{ qtFiles }} arquivo(s) de XML?</span>
        </div>
      </div>
      <hr>
      <div class="row">
        <div class="col-md-12 mt-2">
          <v-button label="Continuar" :nb-btdef="true" @click="handleExecutaImportacao()"></v-button>
          <v-button label="Cancelar" @click="handleRetornar()"></v-button>
        </div>
      </div>
    </div>

    <div class="default-container" v-if="resultList.length > 0">
      <label-title title="Resultado da Importação" class="mb-2"></label-title>
      <hr>
      <!-- <alert v-if="resultList.length > 0" type="warning" :text="xmlcount + ' Nota(s) Importada(s)'"></alert> -->

      <div class="row mt-5 mb-5">
        <div class="col-md-3 col-3 col-3">
          <div class="card text-center">
            <div class="card-header">
              <label class="lbl-title">Nota(s) Importada(s)</label>
            </div>
            <div class="card-body">
              <label class="lbl-edit"> {{ xmlcount }} </label>
            </div>
          </div>
        </div>
      </div>
      <alert v-if="resultList.length > 0" type="warning" text="Consulte as notas fiscais importadas abaixo."></alert>

      <!--
                <label-title title="Detalhes da importação"></label-title>
                <div class="mainbox" v-for="(item, index) in resultList" v-bind:key="index">
                    <div v-if="item.status=='error'" class="mark-red"></div>
                    <div v-if="item.status!='error'" class="mark-green"></div>
                    <div class="box">
                        <div class="row">
                            <div class="col-md-6 col-6">
                                <v-label label="Arquivo"></v-label><br>
                                <span class="data-list">{{ item.filename }}</span>
                            </div>
                            <div class="col-md-6 col-6">
                                <v-label label="Mensagem"></v-label><br>
                                <span class="data-list">{{ item.errormessage }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                -->
      <hr>
      <div class="row col">
        <v-button label="Retornar" @click="handleRetornar" icon="fa-arrow-left"></v-button>
      </div>
    </div>


    <div v-show="false" class="row">
      <div class="col">
        <label>Foto
          <input type="file" ref="file" multiple accept=".xml" @change="handleFileUpload()">
        </label>
      </div>
    </div>

    <hr>

    <div class="default-container">
      <div id="list">
        <bar-list :refresh-button="true" :new-button="false" :pdf-button="false" :xls-button="false"
          single-entity="NF-e Importada" plural-entity="NF-e Importadas" @search="search" @refresh="loadData">
        </bar-list>
        <br>

        <div class="default-container">
          <div class="" v-for="(xmlhist, index) in xmlhistList" :key="xmlhist.chnfe">
            <div class="">
              <div class="row align-items-center" style="font-weight: 500" v-if="index == 0">
                <div class="col-md-1 col-1 text-center">
                  <span class="lbl-list">Série</span>
                </div>
                <div class="col-md-1 col-1 text-center">
                  <label class="lbl-list">Número</label>
                </div>
                <div class="col-md-7 col-7">
                  <label class="lbl-list">Destinatário</label>
                </div>
                <div class="col-md-2 col-2">
                </div>
              </div>

              <div class="row align-items-center" style="font-size: 12px;">
                <div class="col-md-1 col-1 text-center">
                  <span class="data-list">{{ xmlhist.serie }}</span>
                </div>
                <div class="col-md-1 col-1 text-center">
                  <span class="data-list-sm">{{ xmlhist.nnf }}</span>
                </div>
                <div class="col-md-7 col-7">
                  <span class="data-list-sm">{{ xmlhist.dest_xnome }}</span>
                </div>
                <div class="col-md-2 col-2">
                  <div class="float-right">
                    <div class="btn-group">
                      <button type="button" class="btn btn-outline-secondary btn-sm" style="margin-right: 5px"
                        data-toggle="tooltip" data-placement="top" title="Baixar XML da NF-e"
                        @click="handleDownloadXML(xmlhist.xml, xmlhist.chnfe)">xml
                      </button>
                      <button type="button" class="btn btn-outline-secondary btn-sm" style="margin-right: 5px"
                        data-toggle="tooltip" data-placement="top" title="Gerar Danfe PDF"
                        @click="handlePDF(xmlhist.chnfe)">
                        <i class="fa fa-file-pdf-o fa-fw"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <hr>
          </div>
        </div>

      </div>
    </div>





  </div>
</template>

<style></style>



// WEBPACK FOOTER //
// src/forms/importa-xmlhist.vue